import { render } from "./legoTextField.vue?vue&type=template&id=dd4a9b1c"
import script from "./legoTextField.vue?vue&type=script&lang=js"
export * from "./legoTextField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/element/legoTextField/legoTextField.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dd4a9b1c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dd4a9b1c', __exports__)) {
    api.reload('dd4a9b1c', __exports__)
  }
  
  module.hot.accept("./legoTextField.vue?vue&type=template&id=dd4a9b1c", () => {
    api.rerender('dd4a9b1c', render)
  })

}


export default __exports__